import { render } from "./addModal.vue?vue&type=template&id=6f1943e6"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__